import { env } from '@/config'
import getUserRandomName from '@/utils/getRandomUserName'
// import getLocation from "@/utils/getLocation"

const DEFAULT_HEAD = require('../../assets/images/default_user_s.png')

export default {
  namespaced: true,
  state: {
    userInfo: {
      userUuid: '',
      userName: getUserRandomName(),
      userAvatarImg: DEFAULT_HEAD
    }
  },
  getters: {
    userInfo: state => state.userInfo
  },
  mutations: {
    setUserInfo (state, userInfo) {
      userInfo.userAvatarImg = DEFAULT_HEAD
      state.userInfo = { ...state.userInfo, ...userInfo }
    }
  },
  actions: {
    async getNfplusUserByLogin ({ commit, rootState }) {
      const { isNfPlus } = rootState.systemInfo
      if (!isNfPlus) return true
      const stateUserInfo = rootState.userInfo.userInfo
      let hasUserInfo = !!stateUserInfo.userUuid && !!stateUserInfo.phone
      if (hasUserInfo) {
        return hasUserInfo
      }
      const userInfo = await window.nfplusJsbridge.nativeLogin()
      const hasUserUuid = !!userInfo.userUuid
      if (hasUserUuid) {
        commit('setUserInfo', userInfo)
        hasUserInfo = true
      } else {
        hasUserInfo = false
      }
      return hasUserInfo
    },
    async getNfplusUserInfo ({ rootState, commit }) {
      const { isNfPlus } = rootState.systemInfo
      if (!isNfPlus) return
      const stateUserInfo = rootState.userInfo.userInfo
      let hasUserInfo = !!stateUserInfo.userUuid
      if (hasUserInfo) {
        return hasUserInfo
      }
      const userInfo = await window.nfplusJsbridge.getUserInfo()
      hasUserInfo = !!userInfo.userUuid
      if (hasUserInfo) {
        commit('setUserInfo', userInfo)
      }
      return hasUserInfo
    },
    async getWxUserInfo ({ commit, rootState }) {
      const { isWx } = rootState.systemInfo
      if (!isWx) return
      const userInfo = await window.nfWxAuth.getWxUserInfo({
        env,
        needSaveLocalStorage: true
      })
      if (userInfo?.uuid) {
        commit('setUserInfo', userInfo)
      }
    },
    async getUserInfo ({ rootState, dispatch }) {
      const { isWx, isNfPlus } = rootState.systemInfo
      if (isWx) {
        await dispatch('getWxUserInfo')
      }
      if (isNfPlus) {
        await dispatch('getNfplusUserInfo')
      }
    }
  }
}
